import { render } from "./TryLogin.vue?vue&type=template&id=44782070"
import script from "./TryLogin.vue?vue&type=script&lang=ts"
export * from "./TryLogin.vue?vue&type=script&lang=ts"
script.render = render

export default script